import {
  Title,
  EmptyState,
  EmptyStateVariant,
  EmptyStateIcon,
  EmptyStateBody,
} from '@patternfly/react-core';
import MagnifyingGlassIcon from '../../assets/RH_Object_MagnifyingGlass.js'
import './EmptyState.css'
import Utils from "../utils/Customizations";


export default function EmptyStateSuggestions({ topPagesData, trendingSearchesData }) {
  return (
    <>
    {/* removing this for apps that are not customer portal */}
      {/* <p className="troubleshoot-text">Or <a href="https://access.redhat.com/support/cases/#/troubleshoot">troubleshoot your issue</a></p> */}
      <div className="empty-state-container">
      <div className="empty-state__wrapper">
      <EmptyState variant={EmptyStateVariant.small}>
        <EmptyStateIcon icon={MagnifyingGlassIcon} />
        <div className="empty-state__content">
        <Title headingLevel="h1" size="3xl">
          Enter Your Search
        </Title>
        <EmptyStateBody>
          {Utils.getEmptyStateBody()}
        </EmptyStateBody>
        </div>
      </EmptyState>
  </div>

      </div>
    </>
  );
}